const AUXILIAJUD_NAME = 'AuxiliaJud';
const AUXILIAJUD_DEFAULT_LOGO_PATH = '/assets/default-logo.png';

export const getBrandName = (): string => {
  return AUXILIAJUD_NAME;
};

export const getDefaultLogoPath = (): string => {
  return AUXILIAJUD_DEFAULT_LOGO_PATH;
};

export const applyBrandName = (value?: string | null): string => {
  if (!value) return '';

  const brandName = getBrandName();
  return value
    .replace(/AuxiliaJud/g, brandName)
    .replace(/auxiliajud/g, brandName.toLowerCase());
};
